import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import EmailsMon from "./emails";
import ComposeMails from "./composeMails";

export default function MailsRoutes() {
  return (
    <Routes>
      <Route index element={<Navigate to="emails" replace />} />
      <Route path="emails" element={<EmailsMon />} />
      <Route path="compose-mails" element={<ComposeMails />} />
      <Route path="*" element={<Navigate to="/error" replace />} />
    </Routes>
  );
}
